import api from './api';

export interface CreateLeadPayload {
  customerName: string;
  customerPhone: string;
  suggestedBranch: string;
  suggestedModel: string;
  otherComments?: string;
}

export type LeadSubmitter = {
  id: string;
  fullName: string;
  empNo: string;
  branch: string;
  telNo: string | null;
};

export type AdminLeadRow = {
  id: string;
  customerName: string;
  customerPhone: string;
  suggestedBranch: string;
  suggestedModel: string;
  otherComments: string | null;
  createdAt: string;
  submittedBy: LeadSubmitter | null;
};

export const leadsService = {
  async submit(payload: CreateLeadPayload): Promise<{ id: string; message: string }> {
    const response = await api.post('/leads', payload);
    return response.data;
  },

  async listForAdmin(): Promise<AdminLeadRow[]> {
    const response = await api.get<AdminLeadRow[]>('/leads');
    return response.data;
  },
};
